// Instagram.js

import { InstagramEmbed } from 'react-social-media-embed';

const Instagram = (props) => {
    const { dataArray } = props;

    // Filtering data to get an array of instagram post url
    const instagramArray = dataArray.filter((data) => data.fields.contentType.toLowerCase() === 'instagram');

    return (
        <div className="instagram">
            <div className="instagram-heading">
                <h1>FOLLOW US</h1>
                <p>daily updates for new designs and products</p>
            </div>
            
            <div className="instagram-gallery">
                {instagramArray.map((post) => {
                    return (
                        <div key={post.sys.id} className="instagram-gallery__post">
                            <InstagramEmbed url={post.fields.instagramPostUrl}/>
                        </div>
                    );
                })}
            </div>
        </div>
    )
}

export default Instagram;